import React from 'react';
import Preloader from 'src/components/Preloader';
import type { SimilarPackagesProgressProps } from './types';

// import { Preloader } from '@lt/components';

const progressCls = 'similar-packages-progress';

const SimilarPackagesProgress = ({
  baseCls,
  title,
  message,
}: SimilarPackagesProgressProps) => (
  <div className={progressCls}>
    <Preloader className={`${baseCls}__spinner`} />
    <div className={`${baseCls}__title`}>{title}</div>
    <div className={`${baseCls}__message`}>{message}</div>
  </div>
);

export default SimilarPackagesProgress;
